
const toTrackingElements = document.getElementsByClassName('data-tracking-click');
if (toTrackingElements.length > 0) {

    for (let elemento of toTrackingElements) {
        elemento.addEventListener("click", function (event) {
            const eventName = this.getAttribute('data-ga-name');
            const category = this.getAttribute('data-ga-cat');
            const paramName = this.getAttribute('data-ga-param');
            const paramValue = this.getAttribute('data-ga-value');
            const secondParamName = this.getAttribute('data-ga-paramb');
            const secondParamValue = this.getAttribute('data-ga-valueb');

            trackingEvent(eventName, category, paramName, paramValue, null, secondParamName, secondParamValue)
        });
    }
}

const toTrackingDocuments = document.getElementsByClassName('data-tracking-document');
if (toTrackingDocuments.length > 0) {

    for (let elemento of toTrackingDocuments) {
        elemento.addEventListener("click", function (event) {
            const eventName = this.getAttribute('data-ga-name');
            const category = this.getAttribute('data-ga-cat');
            const paramEntity = this.getAttribute('data-ga-entity');
            const paramElement = this.getAttribute('data-ga-item');
            const paramFile = this.getAttribute('data-ga-file');
            const paramType = this.getAttribute('data-ga-type');

            const extraData = [];
            extraData.push({'document_entity': paramEntity});
            extraData.push({'document_element': paramElement});
            extraData.push({'document_file': paramFile});

            trackingEvent(eventName, category, 'document_type', paramType, extraData)
        });
    }
}

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const shared = urlParams.get('sh')
if (shared) {
    trackingEvent('detalleVisitaCompartida', 'Visita', 'shared_token', '0000', null)
}



const formBusquedaElememto = document.getElementById('form_busqueda');
const formAvanzadaElememto = document.getElementById('form_avanzada');
const formFiltros = document.getElementById('form_detalle');

if (formBusquedaElememto) {

    formBusquedaElememto.addEventListener("submit", function (event) {
        const hasResults = this.getAttribute('data-ga-results');
        const params = trackingSearchBody();

        trackingEvent((hasResults ? 'resultadosBusqueda' : 'inicioBusqueda'), (hasResults ? 'Resultados' : 'Inicio'), 'form', 'search', params);
    });
}

if (formAvanzadaElememto) {

    formAvanzadaElememto.addEventListener("submit", function (event) {
        const hasResults = this.getAttribute('data-ga-results');
        const params = trackingSearchBody();

        trackingEvent((hasResults ? 'resultadosBusqueda' : 'inicioBusqueda'), (hasResults ? 'Resultados' : 'Inicio'), 'form', 'search', params);
    });
}

function trackingSearchBody() {
    const basicFormInputs = formBusquedaElememto.getElementsByTagName('input');
    const params = [];

    const advancedFormInputs = formAvanzadaElememto.getElementsByTagName('input');
    const advancedFormExtras = formAvanzadaElememto.getElementsByTagName('select');
    const advancedFormValues = [];

    for (let input of basicFormInputs) {
        const newArray = {};
        newArray[input.getAttribute('name')] = input.value;

        params.push(newArray);
    }

    for (let input of advancedFormInputs) {
        const newArray = {};
        newArray[input.getAttribute('name')] = input.value;

        params.push(newArray);
    }

    for (let input of advancedFormExtras) {
        const newArray = {};
        newArray[input.getAttribute('name')] = input.value;

        params.push(newArray);
    }

    return params;
}



if (formFiltros) {

    formFiltros.addEventListener("submit", function (event) {
        const formFiltrosInputs = formFiltros.getElementsByTagName('input');
        const formFiltrosExtras = formFiltros.getElementsByTagName('select');
        const formFiltrosValues = [];

        for (let input of formFiltrosInputs) {
            const newArray = {};
            newArray[input.getAttribute('name')] = input.value;

            formFiltrosValues.push(newArray);
        }

        for (let input of formFiltrosExtras) {
            const newArray = {};
            newArray[input.getAttribute('name')] = input.value;

            formFiltrosValues.push(newArray);
        }

        const params = formFiltrosValues;

        params.push({'tab': 'asociaciones'});

        trackingEvent('resultadosFiltros', 'Resultados', 'form', 'filters', params);
    });

    window.addEventListener("metrica-tab", function (event) {
        const formFiltrosInputs = formFiltros.getElementsByTagName('input');
        const formFiltrosExtras = formFiltros.getElementsByTagName('select');
        const formFiltrosValues = [];

        for (let input of formFiltrosInputs) {
            const newArray = {};
            newArray[input.getAttribute('name')] = input.value;

            formFiltrosValues.push(newArray);
        }

        for (let input of formFiltrosExtras) {
            const newArray = {};
            newArray[input.getAttribute('name')] = input.value;

            formFiltrosValues.push(newArray);
        }

        const params = formFiltrosValues;
        params.push({'tab': event.detail.tab});

        trackingEvent('resultadosFiltros', 'Resultados', 'form', 'filters', params);
    });
}


function trackingEvent(eventName, category, paramName, paramValue, extraData = null, secondParamName = null, secondParamValue = null) {
    if (Array.isArray(paramValue)) {
        paramValue = JSON.stringify(paramValue);
    }

    const objectToPush = {'event': eventName, 'event_name': eventName, 'event_category': category};

    objectToPush[paramName] = paramValue;

    if (secondParamName && secondParamValue) {
        objectToPush[secondParamName] = secondParamValue;
    }

    if (extraData && extraData.length > 0) {
        extraData.forEach((fieldValue, fieldIndex) => {
            Object.keys(fieldValue).forEach(function (key) {
                if (key != null && key != 'null' && key != '_token') {
                    const cleanedKey = cleanTrackingNames(key);
                    objectToPush[cleanedKey] = fieldValue[key];
                }
            });

        });
    }

    gtag('event', eventName, objectToPush);
}

function cleanTrackingNames(key) {
    switch (key) {
        case 'municipio_alcaldia':
            return 'mpio_alc';
        case 'domicilio_cp':
            return 'dom_cp';
        case 'domicilio_estado':
            return 'dom_edo';
        case 'colonia':
            return 'dom_col';
        case 'nombre_miembro':
            return 'nom_memb';
        case 'nombre_persona':
            return 'nom_pers';
        default:
            return key;
    }
}



